var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5512 16C12.8014 16 11.0586 15.569 9.32284 14.707C7.58705 13.8449 6.02975 12.7271 4.65092 11.3535C3.27209 9.97985 2.15223 8.417 1.29134 6.66492C0.430446 4.91283 0 3.17477 0 1.45072C0 1.05826 0.139983 0.718353 0.419948 0.431012C0.699913 0.143671 1.04287 0 1.44882 0H4.28346C4.73141 0 5.09186 0.112133 5.36483 0.336399C5.6378 0.560666 5.81627 0.890057 5.90026 1.32457L6.46719 3.55322C6.52319 3.94569 6.50919 4.27858 6.4252 4.55191C6.34121 4.82523 6.18723 5.06001 5.96325 5.25624L3.80053 7.23259C4.50044 8.3399 5.26334 9.29654 6.08924 10.1025C6.91514 10.9085 7.83202 11.5988 8.8399 12.1735L10.9186 10.092C11.1566 9.83968 11.4226 9.66448 11.7165 9.56636C12.0105 9.46824 12.3395 9.46124 12.7034 9.54534L14.6772 10.0289C15.1111 10.141 15.4401 10.3408 15.664 10.6281C15.888 10.9155 16 11.2694 16 11.6899V14.5283C16 14.9488 15.86 15.2992 15.5801 15.5795C15.3001 15.8598 14.9571 16 14.5512 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.21586b983beca6ef2f20bf44e6629c96.svg";
export { ForwardRef as ReactComponent };